import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@material-ui/icons/Clear";

import { RootState } from "../../../../app/rootReducer";
import { closeSummary } from "../../../../store/checkoutPage.slide";
import { Potential } from "./Potential";
import { useSummaryStyles } from "./summary.styles";
import { SummaryPackage } from "./SummaryPackage";
import { SummaryDate } from "./SummaryDate";
import { SummaryTotal } from "./SummaryTotal";
import { SummaryAddon } from "./SummaryAddon";

export const SummaryDialog = ({ quoteId }: { quoteId: string }) => {
  const classes = useSummaryStyles();
  const dispatch = useDispatch();
  const { openSummary } = useSelector((state: RootState) => state.checkout);
  const { quote } = useSelector((state: RootState) => state.quote);

  return (
    <Dialog
      open={openSummary}
      onClose={() => {
        dispatch(closeSummary());
      }}
      aria-labelledby="Summary-dialog-title"
      maxWidth="xl"
      fullWidth
      className={classes.summaryDialog}
    >
      <DialogTitle>
        <Box className={classes.summaryDialogTitle}>
          <h2>Summary</h2>
          <IconButton
            onClick={() => {
              dispatch(closeSummary());
            }}
          >
            <ClearIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.summaryDialogContent}>
        <Box>
          {quote?.type.includes("Solar") && <Potential />}
          <SummaryPackage />
          <SummaryAddon quoteId={quoteId} />
          <SummaryDate />
        </Box>
      </DialogContent>
      <DialogActions className={classes.summaryDialogBottom}>
        <Box width={"100%"}>
          <SummaryTotal quoteId={quoteId} />
        </Box>
      </DialogActions>
    </Dialog>
  );
};
